// UI Imports
import { createTheme } from '@mui/material/styles';
import { blue, blueGrey } from '@mui/material/colors';

export default createTheme({
  palette: {
    primary: {
      main: '#0d3559',
    },
    secondary: {
      main: blueGrey[400]
    },
    error: {
      main: '#0d3559',
    },
  },
});